// extracted by mini-css-extract-plugin
export default {"wrap":"image_wrap__sMfhD","detail":"image_detail__kWfSY","threeCtn":"image_threeCtn__FADQo","active":"image_active__QLEK5","detailImg":"image_detailImg__dsGiX"};